import type { SVGProps } from "react";
import * as React from "react";
const SvgSalesforce = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#Salesforce_svg__a)">
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M9.965 5.835A4.209 4.209 0 0 1 13.01 4.53c1.589 0 2.965.883 3.706 2.197a5.118 5.118 0 0 1 2.091-.445c2.86 0 5.18 2.338 5.18 5.223 0 2.886-2.32 5.224-5.18 5.224-.349 0-.69-.035-1.023-.102a3.791 3.791 0 0 1-3.3 1.942 3.767 3.767 0 0 1-1.659-.382 4.313 4.313 0 0 1-8.02-.194 3.976 3.976 0 0 1-.825.086c-2.214 0-4.005-1.817-4.005-4.05 0-1.5.806-2.806 2.003-3.512A4.662 4.662 0 0 1 6.26 4.004c1.508 0 2.858.72 3.705 1.836"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Salesforce_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSalesforce;
